"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCheckboxName = void 0;
var React = require("react");
var lodash_1 = require("lodash");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var buildCheckboxName = function (tag, attributeName) {
    return attributeName + "." + tag.name;
};
exports.buildCheckboxName = buildCheckboxName;
var SelectDivisionAttribute = function (_a) {
    var attributeTags = _a.attributeTags, title = _a.title, attributeName = _a.attributeName, seasonForm = _a.seasonForm;
    if (attributeTags.length < 1) {
        return null;
    }
    var register = seasonForm.register, setValue = seasonForm.setValue, getValues = seasonForm.getValues;
    var checkboxNames = attributeTags.map(function (tag) { return exports.buildCheckboxName(tag, attributeName); });
    var updateAll = function (value) {
        checkboxNames.forEach(function (field) {
            var _a;
            return setValue([
                (_a = {}, _a[field] = value, _a),
            ]);
        });
    };
    var selectAll = function () { updateAll(true); };
    var deselectAll = function () { updateAll(false); };
    var selectedNames = lodash_1.filter(getValues(), function (value, key) { return checkboxNames.find(function (name) { return key === name; }) && value; });
    var allSelected = selectedNames.length === checkboxNames.length;
    var selectText = allSelected ? "Clear All" : "Select All";
    var selectFunction = allSelected ? deselectAll : selectAll;
    var sortedAttributes = lodash_1.sortBy(attributeTags, function (tag) { return tag.id; });
    return (React.createElement("div", { className: "" },
        React.createElement("div", { className: "FieldGroup-label u-padTopMd u-padBottomSm u-flex" },
            title,
            React.createElement("a", { className: "u-sizeFill u-flexAlignSelfEnd u-textRight", onClick: selectFunction }, selectText)),
        React.createElement(teamsnap_ui_1.Grid, { isWithGutter: true }, sortedAttributes.map(function (tag) { return (React.createElement(teamsnap_ui_1.Cell, { key: tag.id, mods: "u-size6of12" },
            React.createElement("div", { key: tag.id, className: "Checkbox Checkbox--pill" },
                React.createElement("input", { className: "Checkbox-input", type: "checkbox", name: exports.buildCheckboxName(tag, attributeName), id: tag.id, value: tag.id, ref: register, defaultChecked: false }),
                React.createElement("label", { className: "Checkbox-label", htmlFor: tag.id }, tag.name)))); }))));
};
exports.default = SelectDivisionAttribute;
//# sourceMappingURL=select-division-attributes.js.map